import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { PanicButtonComponent } from "./panic-button.component";

const DIRECTIVES: any[] = [PanicButtonComponent];

@NgModule({
	imports: [CommonModule, FormsModule],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class PanicButtonModule {}
